export const mutations = {
    setAtividadePosVenda(state, payload) {
        state.atividadePosVenda = payload
    },
    setAtividadesPosVenda(state, payload) {
        state.atividadesPosVenda = payload
    },
    addAtividadePosVenda(state, data){
        state.atividadePosVendas.push(data)
    },
    removeAtividadePosVenda(state, data){
        let index = state.atividadesPosVenda.map(x => x.id).indexOf(data.id);
        state.atividadesPosVenda.splice(index, 1)
    },
    setModalCadastroAtividadePosVenda(state, status) {
        state.modalCadastroAtividadePosVenda = status
    },
   
    setModalExcluirAtividadePosVenda(state, status) {
        state.modalExcluirAtividadePosVenda = status
    },
}

export default {}